/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Frost_Free_Activated_By_NetworkInputs */



/**
* | output |
* | --- |
* | "Frost-free mode activated by network" |
*
* @param {Frost_Free_Activated_By_NetworkInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const frost_free_activated_by_network = /** @type {((inputs?: Frost_Free_Activated_By_NetworkInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Frost_Free_Activated_By_NetworkInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return /** @type {LocalizedString} */ ("Frost-free mode activated by network")
	return /** @type {LocalizedString} */ ("Mode HG activé par réseau")
});